<template>
  <div class="bidder-page">
    <!-- 搜索区域 -->
    <div class="search-section">
        <el-form :model="searchForm" :inline="true" class="search-form">
          <el-form-item>
            <el-input v-model="searchForm.announcementName" placeholder="公告名称" clearable
              style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.projectName" placeholder="招标项目/标段名称" clearable
              style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="tenderNoticeName" label="公告名称" min-width="0">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false">{{ scope.row.tenderNoticeName || '-' }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="agencyName" label="招标代理机构" min-width="0"></el-table-column>
        <el-table-column prop="biddingDocumentAcquisitionStartTime" label="招标文件获取开始时间" min-width="0">
          <template slot-scope="scope">
            {{ scope.row.biddingDocumentAcquisitionStartTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="biddingDocumentAcquisitionEndTime" label="招标文件获取结束时间" min-width="0">
          <template slot-scope="scope">
            {{ scope.row.biddingDocumentAcquisitionEndTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="bidSectionCode" label="标段编号" min-width="0"></el-table-column>
        <el-table-column prop="bidSectionName" label="标段名称" min-width="0"></el-table-column>
        <el-table-column prop="isNeedRegister" label="是否需要报名" min-width="0">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.isNeedRegister === 1 ? '#ff4d4f' : '#333' }">
              {{ scope.row.isNeedRegister === 1 ? '需报名' : '无需报名' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="购标状态" min-width="0">
          <template slot-scope="scope">
            {{ getOrderStatusText(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="0">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="handlePurchase(scope.row)">{{ getActionText(scope.row)
              }}</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" :loading="loading">
        </el-pagination>
      </div>
    </div>
    <!-- 购标弹窗 -->
    <el-dialog title="购标" :visible.sync="purchaseDialog.visible" width="80%" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" class="purchase-dialog">
      <div class="purchase-content" v-loading="purchaseDialog.loading">
        <!-- 投标人信息 -->
        <div class="bidder-info-section">
          <div class="form-grid">
            <!-- 左列 -->
            <div class="form-column">
              <div class="form-item">
                <label>投标人名称：</label>
                <el-input v-model="purchaseDialog.form.userName" disabled></el-input>
              </div>
              <div class="form-item ">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>投标联系人：</label>
                <el-input v-model="purchaseDialog.form.contactPerson" placeholder="请输入投标联系人"></el-input>
              </div>
            </div>
            <!-- 右列 -->
            <div class="form-column">
              <div class="form-item">
                <label>购标日期：</label>
                <el-input v-model="purchaseDialog.form.purchaseDate" disabled></el-input>
              </div>
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>手机：</label>
                <el-input v-model="purchaseDialog.form.mobile" placeholder="请输入手机号" maxlength="11"
                  @input="purchaseDialog.form.mobile = sanitizeMobileInput(purchaseDialog.form.mobile)"></el-input>
              </div>
            </div>
          </div>
        </div>
        <!-- 费用明细 -->
        <div class="cost-details-section">
          <h3 class="section-title">费用明细</h3>
          <el-table :data="costDetails" border style="width: 100%">
            <el-table-column prop="sectionCode" label="标段编码" width="200"></el-table-column>
            <el-table-column prop="sectionName" label="标段名称" min-width="300"></el-table-column>
            <el-table-column prop="documentPrice" label="招标文件售价(元)" width="140"></el-table-column>
            <el-table-column prop="drawingDeposit" label="图纸押金(元)" width="120"></el-table-column>
            <el-table-column prop="offlinePaymentNote" label="线下缴费说明" min-width="250"></el-table-column>
          </el-table>
        </div>
        <!-- 订单汇总和付款 -->
        <div class="order-summary-section">
          <div class="order-total">
            <div class="order-number" v-if="purchaseDialog.form.orderNumber">
              <label>订单号：</label>
              <span class="order-number-value">{{ purchaseDialog.form.orderNumber }}</span>
            </div>
            <div class="total-amount">
              <span class="total-text">
                订单合计金额(元)：<span class="amount">{{ getOrderTotalAmount() }}元</span>
                <span class="amount-detail">(其中标书款:{{ purchaseDialog.form.tenderFee || 0 }}元, 图纸押金:{{
                  purchaseDialog.form.drawingDepositFee || 0 }}元)</span>
              </span>
            </div>
          </div>
          <div class="payment-section">
            <div class="payment-method">
              <label>付款方式：</label>
                  <el-input value="线下支付" disabled style="width: 200px;"></el-input>
            </div>

            <div v-if="purchaseDialog.form.paymentMethod === 'offline'" class="offline-payment-note">
              <span class="warning-text">
                您选择了线下付款,请在下订单后尽快上传线下支付凭证,以免影响后续流程!
              </span>
            </div>
          </div>
        </div>

        <!-- 文件上传 -->
        <div class="upload-section">
          <h3 class="section-title">文件上传</h3>
          <div class="upload-area">
            <el-button type="primary" icon="el-icon-upload2" @click="handlePurchaseUploadDocument">本地上传</el-button>
            <div class="el-upload__tip">支持的文件类型：PDF、Word、图片等，单个文件不能超过10GB</div>
          </div>
          <div class="uploaded-files">
            <el-table :data="purchaseDialog.uploadedFiles" border style="width: 100%">
              <el-table-column prop="fileName" label="文件名称" min-width="200"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handlePurchaseDeleteFile(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelPurchase" icon="el-icon-close">取消</el-button>
        <el-button type="primary" @click="handlePlaceOrder" icon="el-icon-check">下订单</el-button>
      </div>
    </el-dialog>
    <!-- 报名弹窗 -->
    <el-dialog title="报名信息" :visible.sync="registrationDialog.visible" width="80%" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" class="registration-dialog">
      <div class="registration-content" v-loading="registrationDialog.loading">
        <!-- 标段(包)信息 -->
        <div class="section-info-section">
          <h3 class="section-title">标段(包)信息</h3>
          <div class="form-grid">
            <div class="form-column">
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>标段(包)名称：</label>
                <el-input v-model="registrationDialog.form.sectionName" disabled></el-input>
              </div>
              <div class="form-item">
                <label>投标单位：</label>
                <el-input v-model="registrationDialog.form.bidderName" placeholder="请输入投标单位" disabled></el-input>
              </div>
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>投标联系人：</label>
                <el-input v-model="registrationDialog.form.contactPerson" placeholder="请输入投标联系人"></el-input>
              </div>
            </div>
            <div class="form-column">
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>手机：</label>
                <el-input v-model="registrationDialog.form.mobile" placeholder="请输入手机号" maxlength="11"
                  @input="registrationDialog.form.mobile = sanitizeMobileInput(registrationDialog.form.mobile)"></el-input>
              </div>
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>邮箱：</label>
                <el-input v-model="registrationDialog.form.email" placeholder="请输入邮箱"></el-input>
              </div>
            </div>
          </div>
          <!-- <div class="form-item" style="margin-top: 10px; width: 50%; padding-right: 10px;">
            <label>电话：</label>
            <el-input v-model="registrationDialog.form.phone" placeholder="请输入电话"></el-input>
          </div> -->
        </div>
        <!-- 报名资料说明 -->
        <!-- <div class="document-description-section">
          <h3 class="section-title">资格条件</h3>
          <div class="description-content">
            <p>{{bidderQualification}}</p>
          </div>
        </div> -->
        <!-- 上传报名资料 -->
        <div class="upload-section">
          <h3 class="section-title">上传报名资料</h3>
          <el-table :data="uploadDocuments" border style="width: 100%">
            <el-table-column prop="registrationName" label="资料名称"></el-table-column>
            <el-table-column prop="registrationDescription" label="说明"></el-table-column>



            <el-table-column prop="fileName" label="已上传文件名称">
              <template slot-scope="scope">
                <span v-if="!scope.row.fileName && !scope.row.uploadFileId" class="not-uploaded">
                  未上传
                </span>
                <span v-else-if="scope.row.uploadFileId && !scope.row.fileName" class="uploaded-status">
                  已上传
                </span>
                <span v-else>{{ scope.row.fileName }}</span>
              </template>
            </el-table-column>
            <!-- 备注 -->
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                  <el-button  type="success"  size="small" @click="handleUploadDocument(scope.row)">本地上传</el-button>
                  <el-button   type="success"  size="small" @click="handleDeleteDocument(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelRegistration" icon="el-icon-close">取消</el-button>
        <el-button type="primary" @click="handleSubmitRegistration" icon="el-icon-check">提交</el-button>
        <!-- <el-button type="warning" @click="handleSaveDraft" icon="el-icon-video-pause">暂存</el-button> -->
      </div>
    </el-dialog>
    <!-- 文件上传进度对话框 -->
    <el-dialog title="文件上传" :visible.sync="uploadProgress.visible" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" :show-close="false">
      <div class="upload-progress-content">
        <div class="upload-info">
          <i class="el-icon-upload" style="font-size: 24px; color: #409EFF; margin-right: 10px;"></i>
          <span>{{ uploadProgress.fileName }}</span>
        </div>
        <el-progress :percentage="uploadProgress.percentage"
          :status="uploadProgress.status === 'success' ? 'success' : (uploadProgress.status === 'error' ? 'exception' : null)"
          style="margin-top: 20px;">
        </el-progress>
        <div class="upload-status" style="margin-top: 10px; text-align: center;">
          <span v-if="uploadProgress.status === 'uploading'">正在上传...</span>
          <span v-else-if="uploadProgress.status === 'success'" style="color: #67C23A;">上传成功</span>
          <span v-else-if="uploadProgress.status === 'error'" style="color: #F56C6C;">上传失败</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRegistrationList, getRegisterInfo, addRegister, getOrCreateBySectionCode, submitOrder, getOrderDetail } from '@/api/modules/tenderNotice'
import { getBidSectionDetail } from '@/api/modules/agent'
import { createErrorHandler } from '@/utils/handleError'
import { UPLOAD_CONSTANTS, BUSINESS_CONSTANTS, VALIDATION_RULES, timeUtils } from '@/utils/base'
import { deleteBidAtt } from '@/api/modules/make'


import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import Cookies from 'js-cookie'
const CONSTANTS = {
  ...UPLOAD_CONSTANTS,
  ...BUSINESS_CONSTANTS,
  UPLOAD_STATUS: UPLOAD_CONSTANTS.STATUS
}

const ORDER_STATUS_MAP = {
  [CONSTANTS.ORDER_STATUS.NOT_PURCHASED]: '未购标',
  [CONSTANTS.ORDER_STATUS.PURCHASED]: '已购标',
  [CONSTANTS.ORDER_STATUS.PAID]: '已支付'
}

// 购标表单初始值
const getInitialPurchaseForm = () => ({
  bidderName: '',
  contactPerson: '',
  phone: '',
  postalCode: '',
  address: '',
  invoiceCompanyName: '',
  purchaseDate: '',
  mobile: '',
  paymentMethod: '',
  projectName: '',
  sectionName: '',
  tenderFee: 0,
  orderNumber: '',
  orderPrice: 0,
  drawingDepositFee: 0,
  bidSectionCode: '',
  email: ''
})

// 报名表单初始值
const getInitialRegistrationForm = () => ({
  sectionName: '',
  projectName: '',
  bidderName: '',
  contactPerson: '',
  position: '',
  mobile: '',
  email: '',
  phone: ''
})

export default {
  name: 'Registration',
  data() {
    return {
      bidderQualification:'',
      fileBindId: '',
      searchForm: { announcementName: '', projectName: '' },
      pagination: { currentPage: 1, pageSize: CONSTANTS.DEFAULT_PAGE_SIZE, total: 0 },
      tableData: [],
      loading: false,
      purchaseDialog: {
        visible: false,
        loading: false,
        form: getInitialPurchaseForm(),
        uploadedFiles: []
      },
      registrationDialog: {
        visible: false,
        loading: false,
        form: getInitialRegistrationForm()
      },
      uploadDocuments: [],
      currentBidSection: null,
      uploadProgress: { visible: false, percentage: 0, fileName: '', status: null },
      costDetails: [],
      validationRules: VALIDATION_RULES
    }
  },
  mounted() {
    this.getRegistrationList()
    this.errorHandler = createErrorHandler(this)
    this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
  },
  methods: {
    // 获取报名列表
    async getRegistrationList() {
      try {
        this.loading = true
        const params = {
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        const response = await getRegistrationList(params)
        if (response.code === 200) {
          this.tableData = response.data.records || []
          this.pagination.total = response.data.total || 0
        } else {
          this.tableData = []
          this.pagination.total = 0
          this.$message.error(response.msg)
        }
      } catch (error) {
        this.tableData = []
        this.pagination.total = 0
        this.errorHandler.handleError(error, '获取报名列表失败')
      } finally {
        this.loading = false
      }
    },
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.getRegistrationList()
    },

    // 获取报名信息
    async getRegisterInfoData(row) {
      try {
        this.registrationDialog.loading = true
        this.currentBidSection = row
        const response = await getRegisterInfo({
          bidSectionCode: row.bidSectionCode
        })
        if (response.code === 200) {
          console.log(JSON.stringify(response.data));
          this.bidderQualification = response.data.bidRegistration.bidderQualification
          const registrationFiles = (response.data.registrationFiles || []).map(file => ({
            ...file,
            fileGuid: file.uploadFileId || file.fileGuid || ''
          }))
          this.uploadDocuments = registrationFiles
          this.updateRegistrationForm(response.data)
        } else {
          this.$message.error(response.msg)
        }
      } catch (error) {
        this.errorHandler.handleError(error, '获取报名信息失败')
      } finally {
        this.registrationDialog.loading = false
      }
    },

    // 更新报名表单
    updateRegistrationForm(data) {
      // 后端返回字段嵌套在 bidRegistration 下；兼容直接放在 data 顶层的情况
      const source = (data && data.bidRegistration) ? data.bidRegistration : (data || {})
      const fieldMap = {
        sectionName: source.bidSectionName,
        projectName: source.projectName,
        bidderName: source.tendereeName,
        contactPerson: source.relationUser,
        position: source.position,
        mobile: source.userPhone,
        email: source.email,
        phone: source.userTel
      }
      // 仅对非空字段进行回显，保留原有表单值
      Object.keys(fieldMap).forEach(key => {
        const val = fieldMap[key]
        if (val !== null && val !== undefined && val !== '') {
          this.$set(this.registrationDialog.form, key, val)
        }
      })
    },

    // 获取订单状态文本
    getOrderStatusText(row) {
      const { isNeedRegister, tenderFee, drawingDepositFee } = row
      const totalFee = (tenderFee || 0) + (drawingDepositFee || 0)
      // isNeedRegister == 0 && totalFee == 0
      if ( totalFee == 0) {
        return '无需购标'
      }
      return '需要购标'
    },

    /**
     * 获取操作按钮文本
     * registrationStatus: -1=未报名, 0=暂存, 1=提交待审, 3=退回, 9=通过
     * orderStatus: -1=未创建, 0=待支付, 1=已支付, 2=退款, 3=已上传支付凭证待审核
     */
    getActionText(row) {
      const { isNeedRegister, tenderFee, drawingDepositFee, registrationStatus, orderStatus } = row
      const totalFee = (tenderFee || 0) + (drawingDepositFee || 0)
      // 判断是否需要报名
      const needRegistration = isNeedRegister > 0
      // 需要报名的项目
      if (needRegistration) {
        // 根据报名状态判断
        console.log('registrationStatus', registrationStatus)
        switch (registrationStatus) {
          case -1: // 未报名
          case 0:  // 暂存
          case 3:  // 退回
            return '报名'
          case 1:  // 提交待审
            return '待审核'
          case 9:  // 通过
            return this.getOrderActionText(totalFee, orderStatus)
          default:
            return '报名'
        }
      }
      // 无需报名的项目，直接判断购标状态
      return this.getOrderActionText(totalFee, orderStatus)
    },

    /**
     * 根据费用和订单状态获取操作文本
     */
    getOrderActionText(totalFee, orderStatus) {
      // 无费用，直接参与项目
      if (totalFee <= 0) {
        return '参与项目'
      }
      // 有费用，根据订单状态判断
      switch (orderStatus) {
        case -1: // 未创建订单
          return '购标'
        case 0:  // 待支付
          return '上传支付凭证'
        case 1:  // 已支付
          return '参与项目'
        case 2:  // 退款
          return '购标'
        case 3:  // 已上传支付凭证待审核
          return '待审核'
        default:
          return '购标'
      }
    },
    // 处理操作按钮点击
    handlePurchase(row) {
      const actionText = this.getActionText(row)
      switch (actionText) {
        case '购标':
        case '去支付':
          this.getOrCreateBySectionCodeData(row, true)
          break
        case '参与项目':
          this.showTenderFileInfo(row)
          break
        case '报名':
          this.openRegistrationDialog(row)
          break
        case '待审核':
          this.$message.info('当前状态正在审核中，请耐心等待')
          break
        case '上传支付凭证':
          this.getOrCreateBySectionCodeData(row, true)
          break
        default:
          this.openRegistrationDialog(row)
      }
    },

    // 获取购标数据
    async getOrCreateBySectionCodeData(row, isDetail = false) {
      try {
        this.purchaseDialog.loading = true
        const response = await getOrCreateBySectionCode({ sectionCode: row.bidSectionCode })
        if (response.code === 200) {
          if (isDetail) this.openPurchaseDialog(row, response.data)
        } else {
          this.$message.error(response.msg || '获取购标数据失败')
        }
      } catch (error) {
        this.errorHandler.handleError(error, '获取购标数据失败')
      } finally {
        this.purchaseDialog.loading = false
      }
    },

    // 打开购标弹窗
    openPurchaseDialog(row, data) {
      const sectionCode = data.bidSectionCode || row.bidSectionCode || ''
      const sectionName = data.bidSectionName || row.bidSectionName || ''
      const tenderFee = data.tenderFee || 0
      const drawingDepositFee = data.drawingDepositFee || 0

      this.purchaseDialog.form = {
        bidderName: row.agencyName || '',
        contactPerson: data.relationUser || '',
        phone: data.userTel || '',
        postalCode: data.postalCode || '',
        address: data.address || '',
        invoiceCompanyName: data.invoiceName || data.billingCompany || '',
        purchaseDate: timeUtils.getCurrentTime(),
        mobile: data.userPhone || '',
        paymentMethod: data.payType === 1 ? 'offline' : 'online',
        projectName: row.projectName || '',
        sectionName: sectionName,
        tenderFee: tenderFee,
        orderNumber: data.orderNumber || '',
        orderPrice: data.orderPrice || 0,
        drawingDepositFee: drawingDepositFee,
        bidSectionCode: sectionCode,
        email: data.email || '',
        userName:data.userName || '',
      }

      this.costDetails = [{
        sectionCode: sectionCode,
        sectionName: sectionName,
        documentPrice: tenderFee,
        drawingDeposit: drawingDepositFee,
        offlinePaymentNote: data.paymentInstructions || ''
      }]

      // 回显已上传的文件列表（接口字段 uploadFiles -> uploadedFiles）
      const uploadedFiles = (data.uploadFiles || [])
        .filter(item => item.filePath)
        .map(item => ({
          fileName: item.fileName,
          fileId: item.uploadFileId,
          filePath: item.filePath,
          uploadFileId: item.uploadFileId
        }))
      this.purchaseDialog.uploadedFiles = uploadedFiles

      this.purchaseDialog.visible = true
    },
    // 打开报名弹窗
    async openRegistrationDialog(row) {
      try {
        await this.getRegisterInfoData(row)
        this.registrationDialog.visible = true
        this.registrationDialog.form = {
          ...this.registrationDialog.form,
          sectionName: row.bidSectionName,
          bidderName: Cookies.get('userName'),
          projectName: row.projectName
        }
      } catch (error) {
        this.errorHandler.handleError(error, '打开报名对话框失败')
      }
    },

    // 显示招标文件信息
    showTenderFileInfo(row) {
      console.log('row', row);

      this.$alert(
        '您可到“我的项目”中找到该项目，点击进入流程可制作投标文件。',
        '提示',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.getOrCreateBySectionCodeData(row)
          }
        }
      )
    },

    // 获取订单总金额
    getOrderTotalAmount() {
      const { tenderFee = 0, drawingDepositFee = 0, orderPrice = 0 } = this.purchaseDialog.form
      return orderPrice > 0 ? orderPrice : (tenderFee + drawingDepositFee)
    },

    // 取消购标
    handleCancelPurchase() {
      this.purchaseDialog.visible = false
      this.resetPurchaseForm()
    },

    // 提交购标订单
    async handlePlaceOrder() {
      if (!this.validatePurchaseForm()) {
        return
      }
      try {
        this.purchaseDialog.loading = true
        await this.submitPurchaseOrder()
        this.$message.success('订单提交成功！')
        this.purchaseDialog.visible = false
        this.resetPurchaseForm()
        this.getRegistrationList()
      } catch (error) {
        this.errorHandler.handleError(error, '订单提交失败')
      } finally {
        this.purchaseDialog.loading = false
      }
    },

    // 提交购标订单
    async submitPurchaseOrder() {
      const form = this.purchaseDialog.form
      const uploadFiles = this.purchaseDialog.uploadedFiles
        .filter(file => file.fileId)
        .map(file => ({ uploadFileId: file.fileId }))
      const requestData = {
        relationUser: form.contactPerson,
        userTel: form.phone,
        userPhone: form.mobile,
        postalCode: form.postalCode,
        address: form.address,
        buyBidTime: form.purchaseDate,
        payType: form.paymentMethod === 'offline' ? 1 : 2,
        uploadFiles,
        email: form.email,
        billingCompany: form.invoiceCompanyName,
        sectionCode: form.bidSectionCode
      }
      const response = await submitOrder(requestData)
      if (response.code === 200) {
        return response.data
      }
      throw new Error(response.msg || '提交订单失败')
    },

    // 重置购标表单
    resetPurchaseForm() {
      this.purchaseDialog.form = getInitialPurchaseForm()
      this.costDetails = []
      this.purchaseDialog.uploadedFiles = []
    },

    // 处理购标上传文件
    handlePurchaseUploadDocument() {
      this.createFileInput('purchase')
    },

    // 创建文件输入框
    createFileInput(type, row) {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = CONSTANTS.SUPPORTED_FILE_TYPES
      input.onchange = (e) => {
        if (type === 'purchase') {
          this.handlePurchaseFileSelect(e)
        } else {
          this.handleFileSelect(e, row)
        }
      }
      input.click()
    },

    // 处理购标文件选择
    async handlePurchaseFileSelect(event) {
      
      const file = event.target.files[0]
      if (!file || !this.validateFile(file)) return

      try {
        this.showUploadProgress(file)
        const uploadResult = await this.uploadFileWithChunks(file)
        console.log(uploadResult);
        
        this.handlePurchaseUploadResult(uploadResult, file)
      } catch (error) {
        this.handleUploadError(error, file)
      }
    },

    // 验证文件
    validateFile(file) {
      const maxSize = 102400 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10GB')
        return false
      }
      const allowedTypes = CONSTANTS.SUPPORTED_FILE_TYPES.split(',')
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
      if (!allowedTypes.includes(fileExtension)) {
        this.$message.error('不支持的文件类型')
        return false
      }
      return true
    },

    // 处理购标上传结果
    handlePurchaseUploadResult(uploadResult, file) {
      if (uploadResult && uploadResult.success) {
        this.uploadProgress.status = CONSTANTS.UPLOAD_STATUS.SUCCESS
        this.uploadProgress.percentage = 100
        const fileId = uploadResult.fileId || uploadResult.id || ''
        if (fileId) {
          this.purchaseDialog.uploadedFiles.push({
            fileName: file.name,
            uploadTime: new Date().toLocaleString(),
            uploader: '当前用户',
            fileId: fileId
          })
        }
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.success(`文件 ${file.name} 上传成功`)
        }, 1000)
      } else {
        this.uploadProgress.status = CONSTANTS.UPLOAD_STATUS.ERROR
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.error(`文件上传失败: ${uploadResult?.message || '未知错误'}`)
        }, 1000)
      }
    },

    // 处理购标删除文件
    handlePurchaseDeleteFile(row) {
      console.log(row);
      this.$confirm('确定要删除这个文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteBidAtt(row)
   
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    async deleteBidAtt(row) {
      const response = await deleteBidAtt(row.fileId)
      if (response.code === 200) {
        const index = this.purchaseDialog.uploadedFiles.findIndex(item => item.fileId === row.fileId)
        if (index > -1) {
          this.purchaseDialog.uploadedFiles.splice(index, 1)
          this.$message.success('删除成功')

        }
      } else {
        this.$message.error(response.msg)
      }
    },






    // 取消报名
    handleCancelRegistration() {
      this.registrationDialog.visible = false
      this.resetRegistrationForm()
    },

    // 提交报名
    async handleSubmitRegistration() {
      if (!this.validateRegistrationForm()) {
        return
      }
      await this.submitRegistration(CONSTANTS.REGISTRATION_STATUS.SUBMITTED)
    },

    // 保存报名草稿
    async handleSaveDraft() {
      await this.submitRegistration(CONSTANTS.REGISTRATION_STATUS.DRAFT)
    },

    // 提交报名
    async submitRegistration(status) {
      if (!this.currentBidSection) {
        this.$message.error('标段信息丢失，请重新选择')
        return
      }
      const requestData = this.buildRegistrationRequestData(status)
      try {
        this.registrationDialog.loading = true
        const requestData = this.buildRegistrationRequestData(status)
        const response = await addRegister(requestData)
        if (response.code === 200) {
          const message = status === CONSTANTS.REGISTRATION_STATUS.SUBMITTED
            ? '报名提交成功！'
            : '报名信息已暂存！'
          this.$message.success(message)
          this.registrationDialog.visible = false
          this.resetRegistrationForm()
          this.getRegistrationList()
        } else {
          this.$message.error(response.msg)
        }
      } catch (error) {
        this.errorHandler.handleError(error, '提交失败，请重试')
      }
    },

    buildRegistrationRequestData(status) {
      return {
        id: null,
        status: status,
        bidRegistration: {
          bidSectionCode: this.currentBidSection.bidSectionCode,
          relationUser: this.registrationDialog.form.contactPerson,
          userTel: this.registrationDialog.form.phone,
          userPhone: this.registrationDialog.form.mobile,
          email: this.registrationDialog.form.email
        },
        registrationFiles: this.uploadDocuments.map(document => ({
          registrationGuid: document.registrationGuid,
          uploadFileId: document.fileGuid,
          fileGuid: document.fileGuid
        }))
      }
    },

    // 处理上传文件
    handleUploadDocument(row) {
      this.createFileInput('registration', row)
    },

    // 处理文件选择
    async handleFileSelect(event, row) {
      const file = event.target.files[0]
      if (!file || !this.validateFile(file)) return

      try {
        this.showUploadProgress(file)
        const uploadResult = await this.uploadFileWithChunks(file, row)
        this.handleUploadResult(uploadResult, file, row)
      } catch (error) {
        this.handleUploadError(error, file)
      }
    },

    // 显示上传进度
    showUploadProgress(file) {
      this.uploadProgress = {
        visible: true,
        percentage: 0,
        fileName: file.name,
        status: CONSTANTS.UPLOAD_STATUS.UPLOADING
      }
    },
    // 处理上传结果
    handleUploadResult(uploadResult, file, row) {
      if (uploadResult.success) {
        this.uploadProgress.status = CONSTANTS.UPLOAD_STATUS.SUCCESS
        this.uploadProgress.percentage = 100
        
        // 更新当前行的文件名
        if (row && row.registrationGuid) {
          const idx = this.uploadDocuments.findIndex(doc => doc.registrationGuid == row.registrationGuid)
          if (idx > -1) {
            this.$set(this.uploadDocuments[idx], 'fileName', file.name)
          }
        }
        
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.success(`文件 ${file.name} 上传成功`)
        }, 1000)
      } else {
        this.uploadProgress.status = CONSTANTS.UPLOAD_STATUS.ERROR
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.error(`文件上传失败: ${uploadResult.message}`)
        }, 1000)
      }
    },

    // 处理上传错误
    handleUploadError(error, file) {
      this.uploadProgress.status = CONSTANTS.UPLOAD_STATUS.ERROR
      setTimeout(() => {
        this.uploadProgress.visible = false
        this.$message.error(`文件上传失败: ${error.message || '未知错误'}`)
      }, 1000)
    },
    // 上传文件
    async uploadFileWithChunks(file, row) {
      // 每次上传都生成新的 fileBindId，避免复用旧文件 ID
      const fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
      // 将新 fileBindId 回写到 row
      if (row && row.registrationGuid) {
        const idx = this.uploadDocuments.findIndex(doc => doc.registrationGuid == row.registrationGuid)
        if (idx > -1) {
          this.$set(this.uploadDocuments[idx], 'fileGuid', fileBindId)
        }
      }
      let uploadedFileId = null
      const uploadResult = await doFileUpload(file, {
        fileBindId: fileBindId,
        onProgress: (progress) => {
          this.uploadProgress.percentage = Math.round(Number(progress) || 0)
        },
        onSuccess: (r) => {
          uploadedFileId = r.fileId || r.id || ''
          if (row && row.registrationGuid) {
            const idx = this.uploadDocuments.findIndex(doc => doc.registrationGuid == row.registrationGuid)
            if (idx > -1 && uploadedFileId) {
              this.uploadDocuments[idx].uploadFileId = uploadedFileId
            }
          }
        },
        onError: () => { }
      })
      if (uploadResult && uploadedFileId) {
        uploadResult.fileId = uploadedFileId
      }
      return uploadResult
    },

    // 删除文档
    handleDeleteDocument(row) {

      
      this.$confirm('确定要删除该文档吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.clearFileInfo(row)
        this.$message.success('删除成功')
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 清除文件信息
    clearFileInfo(row) {
      // 注意：不清空 registrationGuid，否则再次上传时无法找到对应的文档
      Object.assign(row, {
        fileName: null,
        fileList: [],
        fileGuid: null,
        filePath: null,
        uploadFileId: null
      })
    },

    // 验证购标表单
    validatePurchaseForm() {
      const requiredFields = [
        { field: 'contactPerson', name: '投标联系人' },
        // { field: 'phone', name: '电话' },
        // { field: 'postalCode', name: '邮编' },
        // { field: 'address', name: '通信地址' },
        { field: 'mobile', name: '手机' },
        // { field: 'email', name: '邮箱' },
        // { field: 'invoiceCompanyName', name: '开发票公司名称' }
      ]

      if (!this.validateRequiredFields(requiredFields, this.purchaseDialog.form)) {
        return false
      }

      // if (!this.validateEmail(this.purchaseDialog.form.email)) {
      //   this.$message.error('请输入正确的邮箱格式')
      //   return false
      // }

      // if (!this.validatePhone(this.purchaseDialog.form.phone)) {
      //   this.$message.error('电话只能输入20位以内数字')
      //   return false
      // }

      if (!this.validateMobile(this.purchaseDialog.form.mobile)) {
        this.$message.error('请输入正确的手机号格式')
        return false
      }

      return true
    },

    // 验证报名表单
    validateRegistrationForm() {
      const requiredFields = [
        { field: 'contactPerson', name: '投标联系人' },
        { field: 'mobile', name: '手机' },
        { field: 'email', name: '邮箱' }
      ]
      if (!this.validateRequiredFields(requiredFields, this.registrationDialog.form)) {
        return false
      }
      if (!this.validateEmail(this.registrationDialog.form.email)) {
        this.$message.error('请输入正确的邮箱格式')
        return false
      }
      if (!this.validateMobile(this.registrationDialog.form.mobile)) {
        this.$message.error('请输入正确的手机号格式')
        return false
      }
      
      // 验证报名资料附件必传
      if (this.uploadDocuments && this.uploadDocuments.length > 0) {
        const missingDocuments = this.uploadDocuments.filter(doc => !doc.uploadFileId && !doc.fileName)
        if (missingDocuments.length > 0) {
          const missingNames = missingDocuments.map(doc => doc.registrationName).join('、')
          this.$message.error(`请上传以下报名资料：${missingNames}`)
          return false
        }
      }
      
      return true
    },

    // 验证必填字段
    validateRequiredFields(fields, form) {
      for (let item of fields) {
        if (!form[item.field] || form[item.field].trim() === '') {
          this.$message.error(`请填写${item.name}`)
          return false
        }
      }
      return true
    },

    // 验证邮箱
    validateEmail(email) {
      return this.validationRules.email.test(email)
    },

    validatePhone(phone) {
      return /^\d{1,20}$/.test(phone)
    },

    // 验证手机号
    validateMobile(mobile) {
      return /^1\d{10}$/.test(mobile)
    },

    sanitizePhoneInput(value) {
      return (value || '').replace(/\D/g, '').slice(0, 20)
    },

    sanitizeMobileInput(value) {
      return (value || '').replace(/\D/g, '').slice(0, 11)
    },

    // 处理分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.getRegistrationList()
    },

    // 处理当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getRegistrationList()
    },

    // 预览文件
    handlePreview(row) {
      if (row.filePath) {
        window.open(row.filePath, '_blank')
      } else if (row.fileList && row.fileList.length > 0) {
        const file = row.fileList[0]
        const url = URL.createObjectURL(file)
        window.open(url, '_blank')
      } else {
        this.$message.warning('文件路径不存在，无法预览')
      }
    },

    // 重置报名表单
    resetRegistrationForm() {
      this.registrationDialog.form = getInitialRegistrationForm()
      this.uploadDocuments = []
      this.currentBidSection = null
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-page {
  .apply-minimal-gray-theme();
}

/* 购标弹窗样式 */
.purchase-dialog {
  /deep/ .el-dialog__header {
    background: @gray-50;
    padding: 20px 24px;
    border-bottom: 1px solid @gray-200;
  }

  /deep/ .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-800;
  }

  /deep/ .el-dialog__body {
    padding: 24px;
    background: @gray-50;
  }

  /deep/ .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid @gray-200;
  }
}

.purchase-content {
  .bidder-info-section,
  .cost-details-section,
  .order-summary-section,
  .upload-section {
    margin-bottom: 24px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: @shadow-sm;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .form-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .form-item {
    display: flex;
    align-items: center;

    label {
      min-width: 140px;
      font-size: 14px;
      color: @gray-700;
      margin-right: 12px;
      flex-shrink: 0;
    }

    /deep/ .el-input {
      flex: 1;
    }
  }
}

.purchase-content .section-title {
  font-size: 15px;
  font-weight: 600;
  color: @gray-800;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid @primary-color;
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 20px;
    background: @primary-color;
    border-radius: 2px;
  }
}

.purchase-content .order-summary-section {
  .order-total {
    padding: 16px;
    background: @gray-50;
    border-radius: 4px;
    border-left: 3px solid @primary-color;
  }

  .order-number {
    margin-bottom: 12px;
    font-size: 14px;

    label {
      color: @gray-700;
      margin-right: 10px;
    }
  }

  .order-number-value {
    color: @primary-color;
    font-weight: 600;
    font-size: 15px;
  }

  .total-amount {
    margin-top: 12px;
  }

  .total-text {
    font-size: 14px;
    color: @gray-700;
  }

  .amount {
    font-weight: 600;
    color: @primary-color;
    font-size: 16px;
  }

  .amount-detail {
    margin-left: 10px;
    font-size: 13px;
    color: @gray-600;
  }
}

.purchase-content .payment-section {
  .payment-method {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    label {
      font-size: 14px;
      color: @gray-700;
      margin-right: 12px;
      min-width: 80px;
    }
  }

  .offline-payment-note {
    padding: 12px;
    background: @error-bg;
    border-left: 3px solid @error-color;
    border-radius: 4px;
  }

  .warning-text {
    color: @error-color;
    font-size: 13px;
    line-height: 1.6;
  }
}

.purchase-content .upload-section {
  .upload-area {
    margin-bottom: 16px;

    /deep/ .el-upload__tip {
      color: @gray-600;
      font-size: 13px;
      margin-top: 8px;
    }
  }

  .uploaded-files {
    margin-top: 12px;
  }

  .no-files {
    text-align: center;
    color: @gray-500;
    font-size: 14px;
    padding: 24px;
    background: @gray-50;
    border-radius: 4px;
    border: 1px dashed @gray-300;
  }
}

.dialog-footer {
  text-align: center;
  padding: 0;

  /deep/ .el-button {
    margin: 0 8px;
    min-width: 100px;
    transition: all @transition-base ease;

    &:hover {
      transform: translateY(-1px);
    }
  }
}

/* 报名弹窗样式 */
.registration-dialog {
  /deep/ .el-dialog__header {
    background: @gray-50;
    padding: 20px 24px;
    border-bottom: 1px solid @gray-200;
  }

  /deep/ .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-800;
  }

  /deep/ .el-dialog__body {
    padding: 24px;
    background: @gray-50;
  }

  /deep/ .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid @gray-200;
  }
}

.registration-content {
  .section-info-section,
  .document-description-section,
  .upload-section {
    margin-bottom: 24px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: @shadow-sm;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .form-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .form-item {
    display: flex;
    align-items: center;

    label {
      min-width: 140px;
      font-size: 14px;
      color: @gray-700;
      margin-right: 12px;
      flex-shrink: 0;
    }

    /deep/ .el-input {
      flex: 1;
    }
  }
}

.registration-content .section-title {
  font-size: 15px;
  font-weight: 600;
  color: @gray-800;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid @primary-color;
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 20px;
    background: @primary-color;
    border-radius: 2px;
  }
}

.registration-content .description-content {
  padding: 16px;
  background: @gray-50;
  border-radius: 4px;
  border-left: 3px solid @primary-color;

  p {
    margin: 0;
    font-size: 14px;
    color: @gray-700;
    line-height: 1.6;
  }
}

.registration-content .not-uploaded {
  color: @error-color;
  background: @error-bg;
  border: 1px solid @error-border;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.registration-content .uploaded-status {
  color: @success-color;
  background: @success-bg;
  border: 1px solid @success-border;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
</style>

